module.exports = __webpack_public_path__ + "static/media/surprise.6e70ba4d.jpg";